var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item"},[(_vm.item.icon)?_c('BizIcon',{staticStyle:{"margin-right":"11px"},attrs:{"type":("" + (_vm.item.icon))}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"menu-item-text"},[_vm._v(_vm._s(_vm.item.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }